import { CommonModule } from '@angular/common';
import { Component, effect, input, signal } from '@angular/core';

import { IFiltredDashboardResponse } from '@app/shared/interfaces/dashboard.interface';

import { ChartModule } from 'primeng/chart';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
    selector: 'app-stacked-bar-chart',
    imports: [CommonModule, ChartModule, ProgressSpinner],
    templateUrl: './stacked-bar-chart.component.html',
    styleUrls: ['./stacked-bar-chart.component.scss']
})
export class StackedBarChartComponent {
    loading = input<boolean>(false);
    salesChannelMonthlyData = input<IFiltredDashboardResponse['salesChannel']['monthly']>();

    chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                align: 'end',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    font: { size: 12 }
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                title: {
                    display: true,
                    text: 'Month',
                    font: { size: 14, weight: 'bold' }
                },
                grid: { display: false }
            },
            y: {
                stacked: true,
                title: {
                    display: true,
                    text: 'Sales Number',
                    font: { size: 14, weight: 'bold' }
                },
                ticks: {
                    stepSize: 20
                }
            }
        }
    };

    chartData = signal({
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
            {
                label: 'OTA',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#8DD3C7'
            },
            {
                label: 'Admin',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#017A7D'
            },
            {
                label: 'IBE',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#02494C'
            }
        ]
    });

    constructor() {
        effect(() => {
            this.updateChartData();
        });
    }

    updateChartData() {
        this.chartData.update((value) => ({
            ...value,
            datasets: [
                {
                    ...value?.datasets?.[0],
                    data: this.salesChannelMonthlyData()?.map((item) => item.ota) ?? []
                },
                {
                    ...value?.datasets?.[1],
                    data: this.salesChannelMonthlyData()?.map((item) => item.admin) ?? []
                },
                {
                    ...value?.datasets?.[2],
                    data: this.salesChannelMonthlyData()?.map((item) => item.ibe) ?? []
                }
            ]
        }));
    }
}
